import DOMPurify from "dompurify";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
} from "@mui/material";
import useAlert from "../../common/hooks/useAlert";
import { useEffect, useState } from "react";

export function AlertNotification() {
  const { alert, removeAlert } = useAlert();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (alert) {
      setOpen(true);
    }
  }, [alert]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleExited = () => {
    removeAlert();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      slots={{
        transition: Fade
      }}
      slotProps={{
        transition: { onExited: handleExited }
      }}
    >
      <DialogTitle id="alert-dialog-title">{alert && alert.title}</DialogTitle>
      <DialogContent>
        <Box dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(alert?.message ?? "") }}></Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}
